import { AdminPresenceItem, AdminPresenceItemArray } from '../models/domain/admin.presence.item';
import { Presence, PresenceArray, PresenceStatusTypes } from '../models/live-comm/presence';
import { AdminItem, AdminItemArray } from '../models/domain/admin.item';
import { Subscription } from 'rxjs';
import { Injectable, OnDestroy } from '@angular/core';

import { ssApiService } from './ss-api.service';
import { GlobalService } from './global.service';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class AdminPresenceService implements OnDestroy {


    // public
    public AdminPresences: AdminPresenceItemArray = new AdminPresenceItemArray();

    // public events
    public onAdminsLoaded = new Subject<AdminItemArray>();
    public onAdminPresenceChanged = new Subject<Presence>();
    public onAdminPresenceFullList = new Subject<PresenceArray>();

    // subscriptions
    private ssdb2AdminsLoaded: Subscription;
    private liveFullAdminPresence: Subscription;
    private liveAdminPresenceChanged: Subscription;



    constructor(private ssdb2: ssApiService, private gb: GlobalService) {
        this.SubcribeToEvents();
        this.Refresh();
    }

    Refresh() {
        this.ssdb2.getAdmins().subscribe();
    }

    ngOnDestroy() {
        this.ssdb2AdminsLoaded.unsubscribe();
        this.liveFullAdminPresence.unsubscribe();
        this.liveAdminPresenceChanged.unsubscribe();
    }


    GetOnlineCount(): number {
        return this.AdminPresences.filter(x => x.PresenceStatus == PresenceStatusTypes.Online).length;
    }

    public ChangeMyPresence(status: PresenceStatusTypes) {
        // this.live.SetOwnPresence(status);
    }

    private ChangeAdminPresence(presence: Presence, ignoreStatus: boolean = false) {

        // don't do with find or findindex because there can be duplicates!
        for (let i = 0; i < this.AdminPresences.length; i++) {

            if (this.AdminPresences[i].AdminID == presence.AdminID) {
                // we found the item
                if (!ignoreStatus)
                    this.AdminPresences[i].PresenceStatus = presence.PresenceStatus;

                return;
            }

        }


        // we don't have a presence for this admin
        let newPresence = new AdminPresenceItem();
        newPresence.AdminID = presence.AdminID;
        newPresence.FirstName = presence.AdminName;
        newPresence.PresenceStatus = presence.PresenceStatus;
        newPresence.Email = presence.Email;

        this.AdminPresences.push(newPresence);

    }

    private AddPresenceFromAdmin(admin: AdminItem) {

        let newPresence = new Presence();
        newPresence.AdminID = admin.AdminID;
        newPresence.AdminName = admin.FirstName + ' ' + admin.LastName;
        newPresence.Email = admin.Email;

        this.ChangeAdminPresence(newPresence, true);
    }


    public GetFullName(presence: AdminPresenceItem): string {
        if (presence.LastName != '')
            return presence.FirstName + ' ' + presence.LastName;
        else
            return presence.FirstName;
    }

    SubcribeToEvents() {

        // loaded
        this.ssdb2AdminsLoaded = this.ssdb2.onAdminList.subscribe(
            (data) => {

                data.forEach((admin) => {
                    this.AddPresenceFromAdmin(admin);
                })

                this.onAdminsLoaded.next(data);
            }
        )

    }

}
